<template>
  <main id="blank-layout" class="display-grid w-100v h-100v" />
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#blank-layout {
  .display-grid {
    display: grid;
  }

  .w-100v {
    width: 100vw;
  }

  .h-100v {
    height: 100vh;
  }
}
</style>
